import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface AlumnoInscritoState {
    status: string;
    error: string;
    alumnoInscrito: {
        estadoCiclo: boolean | null;
        puedeAsignarNuevos: number | null;
        inscritos: number | null;
        pendientes: number | null;
        bajas: number | null;
    }

}

const initialState: AlumnoInscritoState = {
    status: 'idle',
    error: '',
    alumnoInscrito: {
        estadoCiclo: null,
        puedeAsignarNuevos: null,
        inscritos: null,
        pendientes: null,
        bajas: null
    }
}

export const fetchAlumnoInscrito = createAsyncThunk('fetchAlumnoInscrito', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 111;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const alumnoInscritoSlice = createSlice({
    name: 'alumnoInscrito',
    initialState,
    reducers: {
        setAlumnoInscrito: (state, action) => {
            state.alumnoInscrito = !action.payload ? initialState.alumnoInscrito : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchAlumnoInscrito.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlumnoInscrito.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.alumnoInscrito = data ? data[0] : null;

            })
            .addCase(fetchAlumnoInscrito.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectAlumnoInscrito = (state: RootState) => state.alumnoInscrito.alumnoInscrito;

export const {  setAlumnoInscrito } = alumnoInscritoSlice.actions;

export default alumnoInscritoSlice.reducer;